import moment from 'moment';
let searchDate = moment().startOf('year').format('YYYY');
export default {
	searchParams: SEARCH_PARAMS(),
	pagingInfo: PAGING_INFO(), //페이지 정보

	srchMm01List: [], //검색 판매월 셀렉트박스
	srchMm02List: [], //검색 조건월 셀렉트박스
	idxScnList: [], //검색 지수구분 셀렉트박스
	carScnList: [], //검색 차량구분 셀렉트박스
	pacScnList: [], //검색 승상구분 셀렉트박스
	flclSpcList: [], //검색 연료전지사양 셀렉트박스
	phmnCdList: [], //검색 현상코드 셀렉트박스
	useTermList: [], //검색 사용기간 셀렉트박스
	occuRegnList: [], //검색 판매지역 셀렉트박스
	ctypeList: [], //검색 클레임타입 셀렉트박스
	opCdList: [], //검색 작업코드 셀렉트박스
	kkList: [], //검색 협력사 셀렉트박스
	carTypeNmList: [], //검색 차종유형 셀렉트박스

	grdList: [], //그리드리스트
	dayCols: [] //그리드 컬럼(년월컬럼)
};

function SEARCH_PARAMS() {
	return {
		partNo: '', //품번
		srchMm01: '', //판매월
		idxScn: '', //지수구분
		useTerm: '', //사용기간
		check: '', //누적
		srchMm02: '', //조건월
		carScn: '', //차량구분
		pacScn: '', //승상구분
		flclSpc: '', //연료전지사양
		ctype: '', //클레임타입
		phmnCd: '', //현상코드
		opCd: '', //작업코드
		occuRegn: '', //판매지역
		opCd: '', //작업코드
		carTypeNm: '', //차종유형

		strtMm01: '', //strtMm01
		endMm01: '', //endMm01
		strtMm02: '', //strtMm02
		endMm02: '' //endMm02
	};
}

function PAGING_INFO() {
	return {
		currentPage: 1,
		endPage: 1,
		pageUnit: 10,
		startPage: 1,
		totalSize: 1
	};
}

export { SEARCH_PARAMS, PAGING_INFO };
